module.exports = __webpack_public_path__ + "static/media/payment_status_paid.52472172.svg";